import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

function notify(type: string, message: string) {
  if (type === "error") {
    toast.error(message, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
  if (type === "success") {
    toast.success(message, {
      position: toast.POSITION.BOTTOM_CENTER,
      className: "toastsuccess",
      bodyClassName: "bodytoast",
    });
  }
}

export { notify };
